module.exports = __webpack_public_path__ + "static/media/tim.a4532fa8.png";